import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-60cb647c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form" }
const _hoisted_2 = {
  key: 0,
  class: "error"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Button")

import { ref,inject } from 'vue';
import Input from '@/components/InputComponent.vue';
import Button from '@/components/ButtonComponent.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'FormComponent',
  setup(__props) {

const description = ref<string>('');

const _addTweet = inject('addTweet');
const addTweet = (input: string) =>{
  if(input === '' || input.length > 30) return;
  _addTweet(input);
  description.value = '';
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", _hoisted_1, [
    (description.value.length >30)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, "30文字以内で入力してください。"))
      : _createCommentVNode("", true),
    _createVNode(Input, {
      description: description.value,
      "onUpdate:description": _cache[0] || (_cache[0] = ($event: any) => ((description).value = $event))
    }, null, 8, ["description"]),
    _createVNode(Button, {
      onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (addTweet(description.value)), ["prevent"]))
    }, {
      default: _withCtx(() => [
        _hoisted_3
      ]),
      _: 1
    })
  ]))
}
}

})